// extracted by mini-css-extract-plugin
export default {"card":"styles_card__y8j0K","content":"styles_content__PguSv","background":"styles_background__YK5AW","text":"styles_text__u8p5X"};